import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container, createMuiTheme, Dialog, DialogActions, DialogContent,
  DialogTitle, Divider, FormControl, Grid, Input, InputAdornment, LinearProgress, Select, Slide, Slider, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CloseIcon from '@material-ui/icons/Close';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import ExcelExport from 'src/components/ExcelExportZimmetIade';
import LockIcon from '@material-ui/icons/Lock';
import {
  CreateWareHouseAddress, getSepetAdet, getUser,

  GetWarehouseAddress, sc,


  setSepetAdet
} from 'src/utils/Common';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};
const CustomTableCellAddress = ({
  row,
  name,
  onChangeSelectWarehouse,
  WarehouseAddress,
  AdresID
}) => {
  const classes = useStyles();
  var ValueSecim = WarehouseAddress.filter(
    d => parseInt(d.Id) === parseInt(row[name])
  );
  var DefaultValue;
  var MalzemeDefaultValue = [];
  MalzemeDefaultValue = WarehouseAddress.filter(item =>
    sc(item.Materials, row.MALZEME_STOK_NO)
  );
  if (ValueSecim[0] === undefined) {
    DefaultValue = { Id: 0, Description: 'Adres Seçiniz!...', Materils: '' };
  } else {
    DefaultValue = ValueSecim[0];
  }
  if (MalzemeDefaultValue.length > 0) {
    DefaultValue = MalzemeDefaultValue[0];
  }
  if (DefaultValue.Id > 0) {
    row.WarehouseAddress = DefaultValue.Id;
  }
  var WarehouseCombo = WarehouseAddress.map(item =>
    sc(item.Materials, row.MALZEME_STOK_NO)
      ? {
        ...item,
        GroupAddress: 'Malzemenin Adresleri'
      }
      : {
        ...item,
        GroupAddress: 'Diger Adresler'
      }
  );

  const defaultProps = {
    options: WarehouseCombo.sort(
      (a, b) => +b.GroupAddress.localeCompare(a.GroupAddress)
    ),
    getOptionLabel: option => option.Description,
    groupBy: option => option.GroupAddress
  };
  if (parseInt(AdresID) > 0) {
    var ValueSecimDeger = WarehouseAddress.filter(
      d => parseInt(d.Id) === parseInt(AdresID)
    );
    row.WarehouseAddress = AdresID;
    DefaultValue = ValueSecimDeger[0];
  }
  return (
    <TableCell padding='none' align="center" className={classes.tableCell}>
      <Autocomplete
        {...defaultProps}
        style={{ width: 200 }}
        autoHighlight
        value={DefaultValue}
        onChange={(event, newValue) => {
          if (newValue === null) {
            return;
          }
          onChangeSelectWarehouse(newValue.Id, name, row);
        }}
        renderInput={params => <TextField {...params} label="" />}
      />
    </TableCell>
  );
};

function Refund() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');
  const TeknisyenKoduTum = 'ALL';
  const filterTeknisyenlerByDurum = (items, durum) =>
    items.filter(
      item =>
        parseInt(item.AKTIF) === parseInt(durum) &&
        parseInt(item.TEKNISYEN_KODU) !== 0
    );
  const [TeknisyenKodu, setTeknisyenKodu] = useState('');
  const [ZimmetAciklama, setZimmetAciklama] = useState('');
  const [TeknisyenData, setTeknisyenData] = useState([]);
  const [TeknisyenZimmetData, setTeknisyenZimmetData] = useState([]);
  const [TeknisyenZimmetDataMain, setTeknisyenZimmetDataMain] = useState([]);
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [Loading, setLoading] = useState(false);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [TeknisyenDurum, setTeknisyenDurum] = useState(1);
  const [TeknisyenDataMain, setTeknisyenDataMain] = useState([]);
  const SessionUser = getUser();
  const selectedTeknisyen = TeknisyenData.find(
    item => parseInt(item.TEKNISYEN_KODU) === parseInt(TeknisyenKodu)
  );
  const selectedTeknisyenText =
    TeknisyenKodu === TeknisyenKoduTum
      ? 'Tüm Teknisyenler'
      : selectedTeknisyen
        ? `${selectedTeknisyen.KUL_TEK_KODU} - ${selectedTeknisyen.ACIKLAMA}`
        : 'Teknisyen seçiniz';
  const getTeknisyenText = teknisyenKodu => {
    const teknisyen = TeknisyenData.find(
      item => parseInt(item.TEKNISYEN_KODU) === parseInt(teknisyenKodu)
    );
    return teknisyen
      ? `${teknisyen.KUL_TEK_KODU} - ${teknisyen.ACIKLAMA}`
      : teknisyenKodu || '-';
  };
  const [Barcode, setBarcode] = useState('');
  const likeAudio = new Audio(BarcodeVoice);
  const ErrorAudio = new Audio(ErrorVoice);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const TeknisyenListesiBos = TeknisyenData.length === 0;
  const handleteknisyenChange = e => {
    setTeknisyenKodu(e.target.value);
    setTeknisyenZimmetData([]);
    setTeknisyenZimmetDataMain([]);
    onSorgulaParam(e.target.value);
  };
  const onChangeSelectWarehouse = (valueParam, nameParam, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    const value = valueParam;
    const name = nameParam;

    const newRows = TeknisyenZimmetData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setTeknisyenZimmetData(newRows);
    setTeknisyenZimmetDataMain(newRows);
  };
  const onChange = (e, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }

    if (parseInt(value) > parseInt(row.MIKTAR)) {
      alert("İade edilen adet Zimmet adedinden büyük olamaz!...");
      return;
    }

    const newRows = TeknisyenZimmetData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setTeknisyenZimmetData(newRows);
    setTeknisyenZimmetDataMain(newRows);
  };
  React.useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    axios
      .get(`/GetTechnician/${SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          setTeknisyenDataMain(response.data);
          setTeknisyenData(filterTeknisyenlerByDurum(response.data, TeknisyenDurum));
        }
      })
      .catch(error => {
        console.log(error);
      });
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);
  const handleDurumChange = e => {
    const yeniDurum = parseInt(e.target.value);
    setTeknisyenDurum(yeniDurum);
    setTeknisyenKodu('');
    setTeknisyenZimmetData([]);
    setTeknisyenZimmetDataMain([]);
    setTeknisyenData(filterTeknisyenlerByDurum(TeknisyenDataMain, yeniDurum));
  };
  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  const loadTeknisyenZimmet = async TeknisyenKoduParam => {
    if (TeknisyenKoduParam === '') {
      setUyariTip('error');
      setUyariAciklama(
        TeknisyenListesiBos
          ? 'Bu durum için teknisyen bulunamadı!...'
          : 'Teknisyen Seçiniz!...'
      );
      setUyari(true);
      return;
    }

    const TeknisyenKodlari =
      TeknisyenKoduParam === TeknisyenKoduTum
        ? TeknisyenData.map(item => item.TEKNISYEN_KODU).filter(Boolean)
        : [TeknisyenKoduParam];

    if (TeknisyenKodlari.length === 0) {
      setUyariTip('error');
      setUyariAciklama('Seçili durum için teknisyen bulunamadı!...');
      setUyari(true);
      return;
    }

    setLoading(true);
    Promise.all(
      TeknisyenKodlari.map(teknisyenKodu =>
        axios
          .get(
            `/GetTechnicianMaterialReturn/${SessionUser.ServiceShopId}/${teknisyenKodu}/${'01.01.2021'}/${'01.01.2021'}`
          )
          .then(response => response.data || [])
          .catch(error => {
            console.log(error);
            return [];
          })
      )
    )
      .then(responses => {
        const TumVeri = responses.reduce((acc, item, index) => {
          const teknisyenKodu = TeknisyenKodlari[index];
          const teknisyenText = getTeknisyenText(teknisyenKodu);
          return acc.concat(
            item.map(row => ({
              ...row,
              TechnicianId: teknisyenKodu,
              TechnicianText: teknisyenText
            }))
          );
        }, []);
        setTeknisyenZimmetData(TumVeri);
        setTeknisyenZimmetDataMain(TumVeri);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onSorgulaParam = TeknisyenKoduParam => {
    loadTeknisyenZimmet(TeknisyenKoduParam);
  };
  function onSorgula() {
    loadTeknisyenZimmet(TeknisyenKodu);
  }
  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const isSelected = name => selected.indexOf(name) !== -1;

  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let TeknisyenZimmetDataOld = [...TeknisyenZimmetData];
    setTeknisyenZimmetData(TeknisyenZimmetDataOld);
    // setTeknisyenZimmetDataMain(TeknisyenZimmetDataOld);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const CikisYapDetay = event => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = TeknisyenZimmetData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );
    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      TechnicianId: item.TechnicianId || TeknisyenKodu,
      Description: ZimmetAciklama,
      ServicePaperNr: item.FIS_NO,
      MaterialCode: item.MALZEME_STOK_NO,
      Count: item.Count,
      WarehouseAddress: item.WarehouseAddress,
      UserId: SessionUser.OrganizationUserId
    }));
    axios
      .post('/SetTechnicianReturnSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        setUyariTip('success');
        onSorgula();
        let ResponseData = response.data[0];
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
      });
  };

  const CikisYap = event => {
    if (
      TeknisyenZimmetData.filter(d => parseInt(d.RowSelected) === parseInt(1))
        .length === 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Seçim yapmadınız!... Lütfen önce seçim yapınız!...');
      setUyari(true);
      return;
    }
    if (ZimmetAciklama.length === 0) {
      setZimmetAciklama('zimmetiade');
    }

    confirmAlert({
      message: 'Sadece seçim yapılan satırlar için işlem yapılacaktır!...',
      buttons: [
        {
          label: 'Evet',
          onClick: () => CikisYapDetay(event)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const playSound = audioFile => {
    audioFile.play();
  };

  const SetBarcodeAddItemKabul = (Barcode, Data) => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialTechnicianDebit/${SessionUser.ServiceShopId
        }/${TeknisyenKodu}/${Barcode}/${1}`
      )
      .then(response => {
        setLoading(false);
        var ID = response.data.split('|')[0];
        var DEPO_ADET = response.data.split('|')[1];
        let Deger = {
          AKTIF_MUADIL: '',
          Count: 1,
          DEPO_ADET: DEPO_ADET,
          FIS_NO: 'Fişsiz Malzeme',
          KULLANILABILIR_ADET: 1,
          MALZEME: Data,
          MALZEME_KODU: 0,
          MALZEME_STOK_NO: Barcode,
          MIKTAR: 1,
          MODEL_KODU: 0,
          PASIF_MUADIL: '',
          RowSelected: 0,
          SIPARISADET: 0,
          SIPARISNO: 'Yok - Yok',
          SIPARIS_TARIHI_FARKI: 100,
          SIP_VERILEBILIR: 1,
          SORUN: 0,
          TARIH: '-',
          TechnicianId: TeknisyenKodu,
          TechnicianText: selectedTeknisyenText,
          WarehouseAddress: 0,
          ID: ID
        };
        let DegerOld = [...TeknisyenZimmetData, Deger];
        setTeknisyenZimmetData(DegerOld);
        setTeknisyenZimmetDataMain(DegerOld);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetMaterialDelete = (event, row, ID) => {
    confirmAlert({
      message:
        'Talepte bulunulan malzeme silinecektir!... Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            SetMaterialDeleteKabul(event, row, ID);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  function getTeknisyenListesi(Durum) {
    axios
      .get(`/GetTechnician/${SessionUser.ServiceShopId}/${Durum}`)
      .then(response => {
        setTeknisyenData(response.data || []);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const SetMaterialDeleteKabul = (event, row, ID) => {
    setLoading(true);
    axios
      .get(`/SetMaterialTechnicianDebitDelete/${ID}`)
      .then(response => {
        setLoading(false);
        var TeknisyenZimmetDataParam = [...TeknisyenZimmetData];
        var filteredIndex = TeknisyenZimmetDataParam.findIndex(
          x => x.ID === ID
        );
        TeknisyenZimmetDataParam.splice(filteredIndex, 1);
        setTeknisyenZimmetData(TeknisyenZimmetDataParam);
        setTeknisyenZimmetDataMain(TeknisyenZimmetDataParam);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetBarcodeAddItem = Barcode => {
    if (Barcode === '') {
      return;
    }
    playSound(ErrorAudio);
    var Varmi = TeknisyenZimmetData.filter(
      d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
    );
    if (Varmi.length > 0) {
      var rowsParam = [
        ...TeknisyenZimmetData.map(item => ({
          ...item
        }))
      ];
      var rowsParamIndex = TeknisyenZimmetData.findIndex(
        d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
      );
      rowsParam[rowsParamIndex].Count =
        parseInt(rowsParam[rowsParamIndex].Count) + 1;
      setTeknisyenZimmetData(rowsParam);
      setTeknisyenZimmetDataMain(rowsParam);
      return;
    }
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        if (response.data === '') {
          setUyari({
            open: true,
            aciklama: Barcode + ' stok numaralı malzeme sistemde tanımlı degil!...',
            tip: 'error'
          });
          return;
        }
        SetBarcodeAddItemKabul(Barcode, response.data);
      })
      .catch(error => {
        setUyari({
          open: true,
          aciklama: 'Bir hata oluştu',
          tip: 'error'
        });
      });
  };

  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };
  const setFilter = (Param) => {
    setBarcode(Param);
    setTeknisyenZimmetData(TeknisyenZimmetDataMain.filter(item => sc(item.MALZEME_STOK_NO, Param) || sc(item.MALZEME, Param) || sc(item.FIS_NO, Param)))
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {

    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${SessionUser.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...TeknisyenZimmetData];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setTeknisyenZimmetData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const exportData = (data) => {
    var json = [];
    return data;
  }


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Stok Girişi - Teknisyen Zimmet İade" />
          <Divider />
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader title="Teknisyen İşlemleri" />
                  <Backdrop className={classes.backdrop} open={Loading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                  <Divider />
                  <CardContent>
                    <FormControl variant="outlined" className={classes.fields}>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        Teknisyen Durumu
                      </Typography>
                      <Typography variant="h6" component="h2">
                        <Select
                          native
                          value={TeknisyenDurum}
                          onChange={handleDurumChange}
                          fullWidth
                          labelId="teknisyen_durum_label"
                          inputProps={{
                            name: 'teknisyen_durum_select',
                            id: 'teknisyen_durum_select'
                          }}
                        >
                          <option value={1}>Aktif</option>
                          <option value={0}>Pasif</option>
                        </Select>
                      </Typography>
                    </FormControl>
                    <FormControl variant="outlined" className={classes.fields}>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        Teknisyen
                      </Typography>
                      <Typography variant="h6" component="h2">
                        <Select
                          native
                          value={TeknisyenKodu}
                          onChange={handleteknisyenChange}
                          fullWidth
                          labelId="teknisyen_label"
                          inputProps={{
                            name: 'teknisyen_select',
                            id: 'teknisyen_select'
                          }}
                        >
                          <option value="">
                            Teknisyen Seçiniz...
                          </option>
                          {!TeknisyenListesiBos && (
                            <option value={TeknisyenKoduTum}>
                              Tüm Teknisyenler
                            </option>
                          )}
                          {TeknisyenData.map(p => {
                            return (
                              <option
                                key={p.TEKNISYEN_KODU}
                                value={p.TEKNISYEN_KODU}
                              >
                                {p.KUL_TEK_KODU + '-' + p.ACIKLAMA}
                              </option>
                            );
                          })}
                        </Select>
                        {TeknisyenListesiBos && (
                          <Typography
                            variant="body2"
                            color="error"
                            style={{ marginTop: 8 }}
                          >
                            Bu durum için teknisyen bulunamadı.
                          </Typography>
                        )}
                      </Typography>
                    </FormControl>
                    <FormControl variant="outlined" className={classes.fields}>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        Açıklama
                      </Typography>
                      <Typography variant="h6" component="h2">
                        <TextField
                          multiline
                          fullWidth
                          value={ZimmetAciklama}
                          onChange={e => setZimmetAciklama(e.target.value)}
                          rows={13}
                          variant="outlined"
                        />
                      </Typography>
                    </FormControl>
                  </CardContent>
                  <Divider />
                  <CardActions className={classes.actionsKesifSms}>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      endIcon={<SearchIcon>Sorgula</SearchIcon>}
                      onClick={onSorgula}
                    >
                      Sorgula
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    subheader={`Teknisyen: ${selectedTeknisyenText}`}
                    action={
                      <div>
                        <ExcelExport JsonData={exportData(TeknisyenZimmetData)} />
                        <Button
                          variant="contained"
                          className={classes.button}
                          color="secondary"
                          endIcon={<SendIcon></SendIcon>}
                          onClick={event => CikisYap(event)}
                        >
                          Gİrİş Yap
                        </Button>
                      </div>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Arama Yapınız..."
                        value={Barcode}
                        name={Barcode}
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => { setFilter(event.target.value) }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        // className={classes.table}
                        size="small"
                        stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">Seçim</TableCell>
                            <TableCell padding='none' align="left">Teknisyen</TableCell>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="left">Hareketsiz(Gün)</TableCell>
                            <TableCell padding='none' align="left">DepoAdet</TableCell>
                            <TableCell padding='none' align="left">AdresAdet</TableCell>
                            <TableCell padding='none' align="left">ZimmetAdet</TableCell>
                            <TableCell padding='none' align="center">İadeAdet</TableCell>
                            <TableCell padding='none' align="left" width="200">Adres</TableCell>
                            <TableCell padding='none' align="center" >Resim</TableCell>
                            <TableCell padding='none' align="center" >Bülten</TableCell>
                            <TableCell padding='none' align="center" >Sipariş</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {TeknisyenZimmetData.sort(
                            (
                              { isEditMode: previousID },
                              { isEditMode: currentID }
                            ) => previousID - currentID
                          )
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              const isItemSelected = isSelected(index);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                >
                                  <TableCell padding='none'>
                                    <Checkbox
                                      onClick={event =>
                                        handleClick(event, row, index)
                                      }
                                      checked={row.RowSelected}
                                      color="primary"
                                      inputProps={{
                                        'aria-labelledby': labelId
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.TechnicianText || selectedTeknisyenText}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    { }
                                    {row.MALZEME.substring(0, 10)}...
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    { }
                                    {row.ZIMMET_SURE_GUN}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {parseInt(row.DEPO_ADET) > 0 ? (
                                      parseInt(row.DEPO_ADET, 10)
                                    ) : (
                                      <b style={{ color: 'red' }}>
                                        {parseInt(row.DEPO_ADET, 10)}
                                      </b>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {parseInt(row.ADRES_ADET) > 0 ? (
                                      parseInt(row.ADRES_ADET, 10)
                                    ) : (
                                      <b style={{ color: 'red' }}>
                                        {parseInt(row.ADRES_ADET, 10)}
                                      </b>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {parseInt(row.MIKTAR, 10)}
                                  </TableCell>

                                  {row.RowSelected === 1 ? (
                                    <CustomTableCell
                                      {...{ row, name: 'Count', onChange, Adet: parseInt(row.ADRES_ADET, 10) }}
                                    />
                                  ) : (
                                    <TableCell
                                      align="center"
                                      padding='none'
                                      className={classes.tableCell}
                                    >
                                      <TextField
                                        type="number"
                                        disabled
                                        value={row.Count}
                                        inputProps={{
                                          min: 0,
                                          style: { textAlign: 'center' }
                                        }}
                                        style={{ width: 80 }}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.WarehouseAddressText || 'Adres Seçiniz!...'}
                                    {/* <AddressSearch
                                      setAdres={setAdres}
                                      value={{
                                        Id: row.WarehouseAddress || '0',
                                        Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                                        Materials: row.Malzemeleri | ''
                                      } || ''}
                                      searchParam={search}
                                      MaterialCode={row.MALZEME_STOK_NO}
                                      ServicePaperNr={row.FIS_NO}
                                      index={index}
                                      Adres={row.WarehouseAddress || 0}
                                      RowSelected={row.RowSelected || 0}
                                      Tip={"Giris"}
                                    /> */}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.SIP_VERILEBILIR === 0 ?
                                      <LockIcon color="error" />
                                      :
                                      <AddShoppingCartIcon
                                        onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                        color="primary"
                                      />
                                    }

                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Refund;
